import { images } from "../constants";

const home = [
  {
    id: 1,
    image: images.home1,
    subtitle: "Welcome to AIByte",
    headingPart1: "Innovative",
    spanText: "AI-Driven",
    headingPart2: "Solutions for Growth",
    description: "Empower your business with intelligent automation and data-driven strategies.",
    buttonText: "Learn More",
    buttonLink: "Services",
  },
  {
    id: 2,
    image: images.home2,
    subtitle: "Welcome to AIByte", 
    headingPart1: "Delivering",
    spanText: "IT Excellence",
    headingPart2: "for Your Success",
    description: "Streamline operations and enhance productivity with our advanced IT solutions.",
    buttonText: "Learn More",
    buttonLink: "Services",
  },
  {
    id: 3,
    image: images.home3,
    subtitle: "Welcome to AIByte",
    headingPart1: "Redefining",
    spanText: "Innovation",
    headingPart2: "with AI Expertise",
    description: "Transform challenges into opportunities with cutting-edge technology solutions.",
    buttonText: "Learn More",
    buttonLink: "Services",
  },
];

export default home;